import {SaveState} from '@deliveriesondemand/dod-data';
import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import Button from '-/components/general/Button';
import {bounce} from '-/styles/utils';

const styles = theme => ({
    save: {
        ...bounce()
    },
    underline: {
        width: 'auto',
        backgroundColor: 'transparent',
        borderRadius: '0 !important',
        border: 'none !important',
        boxShadow: 'none !important',

        '& span': {
            color: '#414042',
            borderBottom: `5px solid ${theme.colors.primary}`,
            paddingBottom: 5
        },
        '& span:hover': {
            borderBottom: '5px solid #414042'
        }
    }
});

class SaveButton extends Component {
    static propTypes = {
        onClick: PropTypes.func,
        title: PropTypes.string
    };

    static defaultProps = {
        onClick: () => {},
        title: 'Save and Finish Later'
    };

    render() {
        const {saveState, onClick, title, classes = {}, underline = false} = this.props;
        const cls = classNames('fa fa-floppy-o', classes.save);
        let innerHtml;
        switch (saveState) {
            case SaveState.Saved:
                innerHtml = <i className={cls}></i>;
                break;
            case SaveState.Saving:
            case SaveState.NotSaved:
            case SaveState.Failed:
                innerHtml = <span>{title}</span>;
                break;
        }

        const buttonCls = underline ? classes.underline : '';

        return (
            <Button tag="a" className={buttonCls} onClick={onClick}>{innerHtml}</Button>
        );
    }
}

const mapStateToProps = state => {
    return {
        saveState: state.api.saveStateExplicit
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(SaveButton));
